import { Link } from 'react-router-dom';

import {
    Nav,
    Navbar,
    NavbarBrand,
    NavbarToggler,
    NavItem,
    NavLink,
    Collapse,
} from 'reactstrap';
import { MdOpenInNew } from 'react-icons/md';

import QaseLogo from '../../assets/images/logo/logo.png';
import QaseWhiteLogo from '../../assets/images/logo/white-logo.png';
import classNames from 'classnames';
import GoogleTranslate from '../google/GoogleTranslate';

const AnonymousNavbar = ({
    logo = '',
    navbarTextLogo = '',
    navbarTextLogoStyle = {},
    showMenus = true,
    showLogin = true,
    showQaseLink = false,
    containerType = true,
    navbarLink = '',
    showPoweredBy = false,
    showGoogleTranslate = false,
    showLogo = true,
    navbarBgColor = '',
}) => {
    const getLogo = () => {
        if (!showLogo) {
            return null;
        }

        if (!!logo) {
            return <img src={logo} alt="Qase" />;
        }

        if (!!navbarTextLogo) {
            return (
                <span
                    className="me-2 q-fs-24 line-height-1 fw-bold"
                    style={navbarTextLogoStyle}
                >
                    {navbarTextLogo}
                </span>
            );
        }

        return <img src={QaseLogo} alt="Qase" />;
    };

    return (
        <Navbar
            container={containerType}
            expand="md"
            fixed="top"
            className="anonymouseNavbar"
            color={navbarBgColor || ''}
        >
            <NavbarBrand
                tag={!!navbarLink ? 'a' : Link}
                to="/"
                href={navbarLink ? navbarLink : '/'}
                target={!!navbarLink ? '_blank' : '_self'}
            >
                {getLogo()}
            </NavbarBrand>
            <NavbarToggler onClick={function noRefCheck() {}} />
            {showMenus ? (
                <Collapse navbar>
                    <Nav className="me-auto" navbar>
                        <NavItem>
                            <NavLink
                                href={`${process.env.REACT_APP_MARKETING_URL}qase-convert`}
                            >
                                Qase For Law Firms
                            </NavLink>
                        </NavItem>
                    </Nav>
                </Collapse>
            ) : null}

            <Nav className="" navbar>
                {showLogin ? (
                    <NavItem>
                        <Link to="/login" className="nav-link">
                            Login
                        </Link>
                    </NavItem>
                ) : null}

                {showQaseLink ? (
                    <NavItem>
                        <Link
                            to="/login"
                            className="nav-link"
                            style={{ fontSize: '14px' }}
                        >
                            Qase <MdOpenInNew />
                        </Link>
                    </NavItem>
                ) : null}

                {showPoweredBy ? (
                    <NavItem>
                        <span
                            className={classNames('nav-link', {
                                'text-white': navbarBgColor === 'dark',
                            })}
                            style={{ fontSize: '14px' }}
                        >
                            <span className="q-fw-500 me-1">Powered By</span>
                            <img
                                src={
                                    navbarBgColor === 'dark'
                                        ? QaseWhiteLogo
                                        : QaseLogo
                                }
                                alt="Qase"
                                style={{ maxHeight: 32 }}
                            />
                        </span>
                    </NavItem>
                ) : null}

                {showGoogleTranslate ? (
                    <NavItem>
                        <GoogleTranslate />
                    </NavItem>
                ) : null}
            </Nav>
        </Navbar>
    );
};

export default AnonymousNavbar;
